import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {Tag} from '../../../models/tag.model';
import {FormTypes} from '../../../helpers/auxiliar';
import {NavController} from '@ionic/angular';
import {TagService} from '../../../services/tag.service';
import {CrudFormBaseComponent} from '../../crud-base/crud-form-base.component';
import {first} from 'rxjs/operators';
import { CarouselService } from 'src/app/services/carousel.service';


@Component({
    selector: 'app-carousel-form',
    templateUrl: './carousel-form.page.html',
    styleUrls: ['./carousel-form.page.scss'],
})

export class CarouselFormPage extends CrudFormBaseComponent implements OnInit {
    tags: any;
    tagsSelected: Tag[] = [];
    show: boolean;

    constructor(private fb: FormBuilder,
                private nav: NavController,
                protected router: ActivatedRoute,
                protected service: CarouselService,
                private tagService: TagService) {
        super(service, router);
    }

    extraStore() {
        this.tagService.getAllTagsNoPagination()
            .pipe(first())
            .subscribe((tags) => {
                this.tags = tags;
                if (this.formType === FormTypes.edit) {
                    this.tagsSelected = this.entity.tags;
                }
            });
    }


    createForm() {
        if (this.formType === FormTypes.new) {
            this.form = this.fb.group({
                title: ['', Validators.required],
                show: [false, null],
            });
        } else {
            this.form = this.fb.group({
                title: [this.entity.title, Validators.required],
                show: [this.entity.show, null],
            });
        }
    }

    submit() {
        if (this.form.valid && this.tagsSelected.length > 0) {
            this.show = false;
            const formData = new FormData();
            formData.append('title', this.form.get('title').value);
            formData.append('show', (this.form.get('show').value) ? '1' : '0');
            formData.append('tags', JSON.stringify(this.tagsSelected));
            
            if (this.formType === FormTypes.new) {
                this.service.save(formData).subscribe(() => {
                    this.nav.navigateRoot(['/admin/carousels/list']);
                });
            }
            if (this.formType === FormTypes.edit) {
                this.service.update(this.entity.id, formData).subscribe();
            }
        } else {
            this.show = true;
            Object.values(this.form.controls).forEach(control => {
                if (control instanceof FormGroup) {
                    Object.values(control.controls).forEach(c => c.markAsTouched());
                } else {
                    control.markAsTouched();
                }
            });
        }

    }


    isTagSelected(tag) {
        if (tag instanceof Tag) {
            return (this.tagsSelected.find((item: Tag) => {
                return item.id === tag.id;
            }));
        }
    }


    selectTag(tag) {
        if (tag instanceof Tag) {
            const idx = this.tagsSelected.findIndex((item: Tag) => {
                return item.id === tag.id;
            });

            if (idx > -1) {
                this.tagsSelected.splice(idx, 1);
            } else {
                this.tagsSelected.push(tag);
            }
        }
    }
}

